import React, { Component } from "react";
import { Button, Table } from "react-bootstrap";

import Pagination from '@inspinia-react/pagination'

import { api, getBranchOwner, get } from "@config";
export default class NFeTransperterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
    this.handleActionClick = this.handleActionClick.bind(this);
  }
  getList() {
    const branch = getBranchOwner().id;
    const url = `${api.nfeTransporter}?branch_owner=${branch}`;
    const payload = (list) => this.setState({ ...this, list });
    get(url, payload);
  }

  handleActionClick(item) {
    if (typeof this.props.action === "function") {
      this.props.action(item);
    }
  }
  UNSAFE_componentWillMount() {
    this.getList();
  }
  render() {
    return ( 
      <Pagination
      labels={["", "Nome", "CPF/CNPJ", "IE"]}
      itemsPerPage={10}
      items={this.state.list}
      dataComponent={(item, _) => {
        return [
          <td>{this.props.action ? (
            <i
              className="btn btn-sm fas fa-plus ml-1 text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => this.handleActionClick(JSON.stringify(item))}
            ></i>
          ) : (
              <i
                onClick={() => {
                  if (this.props.onEdit) {
                    this.props.onEdit(item);
                  }
                }}
                className="btn btn-sm fas fa-edit ml-1 text-primary"
                style={{ cursor: "pointer" }}
              ></i>
            )}
          </td>,
          <td> {item.name} </td>,
          <td>{item.cpf || item.cnpj}</td>,
          <td>{item.state_registry}</td>
        ]
      }}
    />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/transporter/list.jsx